export default "__VITE_ASSET___RhZYjjD__"